/*
 * Responsible for loading specific popups. Acts as a base to other specific popups or other components that are loaded as popups
 */
import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-popup-base',
  templateUrl: './popup-base.component.html',
  styleUrls: ['./popup-base.component.scss']
})
export class PopupBaseComponent implements OnInit {
  @Input() public data$;
  @Input() public component$;
  options$: any;

  /*
    The { static: true } option was introduced to support creating embedded views on the fly. When you are creating a view dynamically and want to access the TemplateRef,
    you won't be able to do so in ngAfterViewInit as it will cause a ExpressionHasChangedAfterChecked error. Setting the static flag to true will create your view in ngOnInit.
    Nevertheless:
    In most other cases, the best practice is to use {static: false}.
   */
  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.component$);
    const component = this.container.createComponent(componentFactory);
    // @ts-ignore
    component.instance.data$ = this.data$;
  }
}
